import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

// import addCookieWithConsent from '../../utilities/addCookieWithConsent';
import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

// import {
  
// } from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get organization invites
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetOrganizationInvitesLog = packet => {
  return {
    type: 'REQUEST_GET_ORGANIZATION_INVITES_LOG',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetOrganizationInvitesLogSuccess = data => ({
  type: 'RECEIVE_GET_ORGANIZATION_INVITES_LOG_SUCCESS',
  data
})

export const receiveGetOrganizationInvitesLogFail = data => ({
  type: 'RECEIVE_GET_ORGANIZATION_INVITES_LOG_FAIL',
  data
})

export const tryToGetOrganizationInvitesLog = packet => (dispatch, getState) => {

  dispatch(requestGetOrganizationInvitesLog(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  let params = {};
  if(packet.startAfter){
    params.startAfter = packet.startAfter;
  }

  return fetch('/api/organizations/invites/log/' + packet.id  + '?' + new URLSearchParams(params), {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetOrganizationInvitesLogSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetOrganizationInvitesLogFail({errors:e, lastSubmit: packet}));
    })
}
